import React, { useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Box,
  InputAdornment,
  Stack,
  alpha,
  useTheme,
  CircularProgress,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  Person,
  VpnKey,
  Login as LoginIcon,
  Verified,
  Launch,
} from "@mui/icons-material";
import api from "../api";

export default function LoginPage({ setUser }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleLogin = async () => {
    if (!username || !password) {
      setError("Lütfen kullanıcı adı ve şifrenizi giriniz.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/login", { username, password });
      if (res.data.success) {
        setUser(res.data.user);
        localStorage.setItem("fieldUser", JSON.stringify(res.data.user));
        localStorage.setItem("fieldToken", res.data.token);

        // HATA BURADAYDI: Sadece admin değil, tüm yöneticiler admin paneline gitmeli.
        const role = res.data.user.role;
        if (
          role === "admin" ||
          role === "project_coordinator" ||
          role === "team_leader"
        ) {
          navigate("/admin");
        } else {
          navigate("/field");
        }
      }
    } catch (err) {
      setError("Giriş başarısız! Bilgilerinizi kontrol ediniz.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: `radial-gradient(circle at 20% 20%, ${alpha(theme.palette.primary.main, 0.08)} 0%, transparent 40%), 
                    radial-gradient(circle at 80% 80%, ${alpha(theme.palette.secondary.main, 0.08)} 0%, transparent 40%),
                    #f9fafb`,
        p: 2,
      }}
    >
      <Card
        elevation={0}
        sx={{
          maxWidth: 400,
          width: "100%",
          borderRadius: "28px",
          border: "1px solid",
          borderColor: "divider",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.08)",
          bgcolor: "#fff",
          mb: 4,
        }}
      >
        <CardContent sx={{ p: { xs: 4, sm: 6 } }}>
          {/* HTC LOGO VE MARKA */}
          <Stack alignItems="center" spacing={1} sx={{ mb: 5 }}>
            <Box
              sx={{
                width: 70,
                height: 70,
                bgcolor: "primary.main",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                boxShadow: `0 12px 24px ${alpha(theme.palette.primary.main, 0.2)}`,
                mb: 2,
              }}
            >
              <Typography
                variant="h4"
                fontWeight="900"
                sx={{ letterSpacing: "-2px" }}
              >
                HTC
              </Typography>
            </Box>
            <Typography
              variant="h5"
              fontWeight="800"
              sx={{ color: "#1a202c", letterSpacing: "-0.5px" }}
            >
              Veri Paneli
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: "center" }}
            >
              Arazi takip ve analiz sistemi için kimliğinizi doğrulayın.
            </Typography>
          </Stack>

          {error && (
            <Alert
              severity="error"
              variant="filled"
              sx={{ mb: 3, borderRadius: "12px", fontSize: "0.8rem" }}
            >
              {error}
            </Alert>
          )}

          <Stack spacing={2.5}>
            <TextField
              fullWidth
              label="Kullanıcı Adı"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ fontSize: 20, color: "text.disabled" }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: "14px", bgcolor: "#fcfdfe" },
              }}
            />

            <TextField
              fullWidth
              label="Şifre"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleLogin()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <VpnKey sx={{ fontSize: 20, color: "text.disabled" }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: "14px", bgcolor: "#fcfdfe" },
              }}
            />

            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleLogin}
              disabled={loading}
              sx={{
                mt: 1,
                py: 1.8,
                borderRadius: "14px",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "1rem",
                boxShadow: `0 10px 20px -5px ${alpha(theme.palette.primary.main, 0.4)}`,
              }}
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <LoginIcon />
                )
              }
            >
              {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Typography variant="caption" sx={{ mt: 3, color: "text.disabled" }}>
        © 2026 v1.0.214122103101 | Secure Access
      </Typography>
    </Box>
  );
}
